export const MobileBackgroundSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 375 202"
    >
      <g clipPath="url(#a)">
        <path fill="#FFF3E6" d="M0 0h375v202H0z" />
        <path
          fill="#FFBF6E"
          d="M347.097 28.557h-28.443v28.631h28.443z"
          opacity=".3"
        />
        <path fill="#F0F1FA" d="M347.097-.073h-28.443v28.63h28.443z" />
        <path
          fill="#FFBF6E"
          d="M347.097 86.493h-28.443v28.968h28.443z"
          opacity=".1"
        />
        <path fill="#FFBF6E" d="M347.097 144.427h-28.443v28.968h28.443z" />
        <path fill="#FF4F00" d="M375.878 28.557h-28.781v28.631h28.781z" />
        <path fill="#EBE9F7" d="M347.097 173.395h-28.443v28.631h28.443z" />
        <path
          fill="#FFBF6E"
          d="M375.878.114h-28.781v28.63h28.781z"
          opacity=".2"
        />
        <path fill="#FF4F00" d="M375.878 86.493h-28.781v28.968h28.781z" />
        <path
          fill="#FFBF6E"
          d="M375.878 57.188h-28.781v29.304h28.781z"
          opacity=".2"
        />
        <path
          fill="#CDE4E1"
          d="M375.878 144.427h-28.781v28.968h28.781z"
          opacity=".5"
        />
        <path
          fill="#FFBF6E"
          d="M375.878 115.46h-28.781v28.968h28.781z"
          opacity=".2"
        />
        <path fill="#2B2358" d="M347.053-.373h-28.781v28.968h28.781z" />
        <path
          fill="#C1B7FF"
          d="M286.148 22.158h-28.781v28.968h28.781z"
          opacity=".2"
        />
        <path
          fill="#C1B7FF"
          d="M257.356-6.92h-28.781v28.968h28.781zM232.346 162.556h-28.781v28.968h28.781z"
          opacity=".1"
        />
        <path
          fill="#C1B7FF"
          d="M168.787 179.766h-28.781v28.968h28.781zM88.416 150.752h-28.78v28.968h28.78z"
          opacity=".05"
        />
        <path
          fill="#C1B7FF"
          d="M203.576 22.261h-28.781V51.23h28.781z"
          opacity=".1"
        />
        <path
          fill="#C1B7FF"
          d="M146.222-9.726h-28.781v28.968h28.781zM82.024 35.163H53.243v28.968h28.78z"
          opacity=".05"
        />
        <path
          fill="#C1B7FF"
          d="M289.873 144.427h-28.781v28.968h28.781z"
          opacity=".4"
        />
        <path
          fill="#FFBF6E"
          d="M375.878 173.395h-28.781v28.631h28.781z"
          opacity=".1"
        />
        <path fill="#FF4F00" d="M318.654 173.395h-28.781v28.631h28.781z" />
        <path
          fill="#FFF3E6"
          d="m312.22 192.157-2.761 2.747v-10.425l-11.446 11.4-1.961-1.95 11.46-11.387h-10.48l2.762-2.747h12.426v12.362ZM369.604 47.53l-2.761 2.747V39.852l-11.446 11.4-1.961-1.95 11.46-11.386h-10.48l2.762-2.747h12.426V47.53Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h375v202H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
